import React from 'react';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { saveExpensas } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { useAuthorization } from '@/auth/hooks/useAuthorization';
import { withRequiredTramite } from './withRequiredTramite';

const Expensas: React.FC = () => {
  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'expensas',
    defaultData: {
      libredeuda: null,
      libredeuda_path: null,
    },
    saveFunction: saveExpensas,
    successMessage: 'Expensas Guardado con éxito',
    errorTitle: 'Error al grabar Expensas',
  });

  const { canManageTramites, canUploadTramitesFiles } = useAuthorization();

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'libredeuda',
      label: 'Libre deuda:',
      inline: true,
      visible: isUpdate,
      readOnly: !canUploadTramitesFiles,
      helpText: 'Acción a realizar por la tramitadora o vendedor',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Expensas"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="expensas"
    />
  );
}

export default withRequiredTramite(Expensas);
